const items = [
  'General Practice',
  'Same-Day Visits',
  'Fear-Free Approach',
  'Open 6 Days',
];

export default function TrustStrip() {
  return (
    <section className="bg-white border-b border-line">
      <div className="max-w-container mx-auto px-5 md:px-12 py-5">
        <div className="flex flex-wrap items-center justify-center md:justify-between gap-x-10 gap-y-3">
          {items.map((label, i) => (
            <div key={label} className="flex items-center gap-10">
              <span className="text-[13px] md:text-[14px] font-medium tracking-[0.02em] text-ink/75 whitespace-nowrap">
                {label}
              </span>
              {i < items.length - 1 && (
                <span className="hidden md:inline-block w-1 h-1 rounded-full bg-line" aria-hidden />
              )}
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}